import { createPaymentIntentAPI, PaymentIntent } from '@/services';

export async function createPaymentIntent(): Promise<PaymentIntent> {
  try {
    const response = await createPaymentIntentAPI();
    return response;
  } catch (error) {
    console.log(error);
    throw 'Error creating Payment Intent';
  }
}
